import React from 'react';
import TaggedContent from '@ui/TaggedContent';

const RecentArticles = () => (
  <TaggedContent tagName="giving" sectionTitle="Recent articles about giving" />
);

export default RecentArticles;



// WEBPACK FOOTER //
// ./src/give/RecentArticles.js